import { PRODUCTS_LOADING } from "./types";

export default () => {
    return { type: PRODUCTS_LOADING };
};
